import Box from '@mui/material/Box';
import { colours } from '../theme';

export type StatusTone = 'live' | 'success' | 'fault' | 'neutral' | 'off' | 'offline';

const tone: Record<StatusTone, { dot: string; text: string; hollow?: boolean }> = {
  live: { dot: colours.chargeMint, text: colours.chargeMint },
  success: { dot: colours.availableGreen, text: colours.availableGreen },
  fault: { dot: colours.faultRed, text: colours.faultRed },
  neutral: { dot: colours.graphite, text: colours.nearBlack },
  off: { dot: colours.graphite, text: colours.graphite, hollow: true },
  offline: { dot: colours.offlineOrange, text: colours.offlineOrange },
};

/** A status is always a dot and a word, never colour alone. */
export function StatusLabel({ tone: t, children }: { tone: StatusTone; children: string }) {
  const s = tone[t];
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, color: s.text, fontWeight: 500, whiteSpace: 'nowrap' }}>
      <Box
        component="span"
        aria-hidden
        sx={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, ...(s.hollow ? { border: `1.5px solid ${s.dot}` } : { bgcolor: s.dot }) }}
      />
      {children}
    </Box>
  );
}
